import { z } from "zod";

export const overlayColorTokens = [
  "white",
  "black",
  "beige",
  "grey",
  "red",
] as const;

const colorTokenSchema = z.enum(overlayColorTokens).optional().catch(undefined);

export const sizeSelectorOverlaySchema = z
  .object({
    Active: z.union([z.boolean(), z.string()]).optional(),
    Headline: z.string().optional(),
    SupportingText: z.string().optional(),
    Caption: z.string().optional(),
    CategoryUri: z.string().optional(),
    BackgroundColor: colorTokenSchema,
    TypographyColor: colorTokenSchema,
    ButtonColor: colorTokenSchema,
    ButtonTextcolor: colorTokenSchema,
    _uid: z.string().optional(),
  })
  .passthrough();

export type SizeSelectorOverlayProps = z.infer<
  typeof sizeSelectorOverlaySchema
>;
export type OverlayColorToken = (typeof overlayColorTokens)[number];

/**
 * Checks if the overlay is active.
 * @param active - The active state of the overlay.
 * @returns True if the overlay is active, false otherwise.
 */
export const isOverlayActive = (
  active: SizeSelectorOverlayProps["Active"],
): boolean => active === true || active === "true";
